import 'underscore';
import userData from 'tradera-apps/syi/script/app_react/services/user-data';

var _paymentOptions;
var _paymentOptionsPresentationData;
var initialState;

const initModuleGlobals = () => {
    if (initialState) {
        return initialState;
    }

    _paymentOptions = userData.paymentOptions;
    _paymentOptionsPresentationData = [
        { text: 'Kontant vid avhämtning', value: 'Cash' },
        {
            text: 'PayPal',
            value: 'Paypal',
            isCreditCard: true,
            isSecure: true,
            helpModalId: 'info-modal-payment-paypal'
        },
        {
            text: 'Manuell överföring till bankkonto',
            value: 'Account',
            top: true,
            helpModalId: 'info-modal-payment-account'
        },
        {
            text: 'Swish',
            value: 'Swish',
            isPhone: true,
            helpModalId: 'info-modal-payment-swish'
        },
        { text: 'PlusGiro / Bankgiro', value: 'Plusgiro' },
        { text: 'Mot postförskott', value: 'Postforskott', hasFee: true },
        { text: 'Braintree', value: 'Braintree' }
    ];

    initialState = {
        displayPaymentOptions: '',
        paymentOptionGroups: [],
        selectedPaymentOptions: userData.braintree.isBraintreeOnly
            ? ['Braintree']
            : [],
        validationError: null,
        uiCheckedPaymentOptions: [],
        takeawaySelected: false
    };
};

function validate(newState) {
    if (userData.braintree && userData.braintree.isBraintreeOnly) {
        if (
            newState.selectedPaymentOptions.length === 1 &&
            newState.selectedPaymentOptions[0] === 'Braintree'
        ) {
            newState.validationError = null;
        } else {
            newState.validationError = 'Utkastet har fel betalsätt';
        }
    } else {
        var paymentOptions = newState.selectedPaymentOptions;
        var hasAnyValidPayment = _.some(paymentOptions, po => po);
        newState.validationError = hasAnyValidPayment ? null : 'Ange betalsätt';
    }
    return newState;
}

function forceBraintreeIfNeeded(state) {
    if (userData.braintree && userData.braintree.isBraintreeOnly) {
        state.selectedPaymentOptions = ['Braintree'];
        state.uiCheckedPaymentOptions = ['Braintree'];
    }
}

function shapePaymentOptions(state) {
    var filteredPaymentOptions = _.map(_paymentOptions, function(
        paymentOption
    ) {
        var presentationData = _.find(_paymentOptionsPresentationData, function(
            pd
        ) {
            return pd.value == paymentOption.paymentType;
        });
        paymentOption.selected = _.find(state.uiCheckedPaymentOptions, function(
            selectedPaymentOption
        ) {
            return selectedPaymentOption == paymentOption.paymentType;
        });
        return _.assign(presentationData, paymentOption);
    })
        .filter(function(paymentOption) {
            return paymentOption && !!paymentOption.value;
        })
        .filter(function(paymentOption) {
            return state.takeawaySelected || paymentOption.value !== 'Cash';
        });

    state.displayPaymentOptions = _.filter(filteredPaymentOptions, function(
        po
    ) {
        return po.selected;
    })
        .map(function(po) {
            return po.text;
        })
        .join(', ');
    var paymentOptionsTop = _.filter(filteredPaymentOptions, function(po) {
        return po.top || po.selected;
    });
    state.selectedPaymentOptions = _.filter(filteredPaymentOptions, function(
        paymentOption
    ) {
        if (!paymentOption || !paymentOption.value) {
            return false;
        }
        return paymentOption.selected;
    }).map(function(paymentOption) {
        return paymentOption.value;
    });
    state.paymentOptionGroups = [
        {
            visible: true,
            paymentOptions: paymentOptionsTop,
            showToggle:
                _.filter(filteredPaymentOptions, function(po) {
                    return !po.top && !po.selected;
                }).length > 0
        },
        {
            visible: paymentOptionsTop.length === 0,
            paymentOptions: _.filter(filteredPaymentOptions, function(po) {
                return !po.top && !po.selected;
            }),
            showToggle: false
        }
    ];
    forceBraintreeIfNeeded(state);
}

export default (state, action) => {
    initModuleGlobals();
    if (!state) {
        shapePaymentOptions(initialState);
        state = validate(initialState);
    }
    switch (action.type) {
        case 'SET_PAYMENT_OPTIONS': {
            const newState = {
                ...state,
                uiCheckedPaymentOptions: action.selectedPaymentOptions
            };
            shapePaymentOptions(newState);
            return validate(newState);
        }
        case 'TOGGLE_ALL_VISIBLE': {
            const newState = { ...state };
            newState.allVisible = !newState.allVisible;
            return validate(newState);
        }
        case 'SET_CATEGORY_WARNING': {
            const newState = {
                ...state
            };
            return validate(newState);
        }
        case 'SET_TAKEAWAY_SELECTED': {
            const newState = {
                ...state,
                takeawaySelected: action.payload.takeawaySelected
            };
            shapePaymentOptions(newState);
            return validate(newState);
        }
        case 'ENSURE_ANY_PAYMENT_OPTION_FOR_CHARITY': {
            const newState = { ...state };
            const hasAnyValidPayment = _.some(
                newState.selectedPaymentOptions,
                po => po
            );
            if (!hasAnyValidPayment) {
                newState.selectedPaymentOptions = ['Account'];
                newState.uiCheckedPaymentOptions = ['Account'];
            }
            shapePaymentOptions(newState);
            return validate(newState);
        }
        default:
            return state;
    }
};
